uic-table-column-custom {
  display: none;
}
